import { validationIsEqual } from '../status';
import { validateBase64File } from '@om/validation';
import {
    ID_UPLOAD_SET_VALUE,
    LICENSE_UPLOAD_SET_VALUE,
    LOG_BOOK_UPLOAD_SET_VALUE,
    VALUATION_REPORT_SET_VALUE,
    INSPECTION_PHOTO_SET_VALUE,
    //additional ug
    CAR_FRONT_PHOTO_SET_VALUE,
    CAR_BACK_PHOTO_SET_VALUE,
    CHASSIS_NUMBER_PHOTO_SET_VALUE,
    INTERIOR_DASHBOARD_PHOTO_SET_VALUE,
    INTERIOR_RADIO_PHOTO_SET_VALUE,
    ENGINE_PHOTO_SET_VALUE,
    setIdUploadValid,
    setLicenseUploadValid,
    setLogBookUploadValid,
    setValuationReportUploadValid,
    setInspectionPhotoValid,
    //additional ug
    setCarFrontViewPhotoValid,
    setCarBackViewPhotoValid,
    setChassisNumberPhotoValid,
    setCarDashboardPhotoValid,
    setInteriorRadioPhotoValid,
    setEnginePhotoValid,
    CAR_RIGHT_PHOTO_SET_VALUE,
    CAR_LEFT_PHOTO_SET_VALUE,
    setCarRightPhotoValid,
    setCarLeftPhotoValid,
} from '../../../actions/ugMotorInsurance/Documents';

let prevValidationAction = null;
export const documentsUploadValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case ID_UPLOAD_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'ID',
                    required: true,
                });
                return setIdUploadValid(error);

            case LICENSE_UPLOAD_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'License',
                    required: true,
                });
                return setLicenseUploadValid(error);

            case LOG_BOOK_UPLOAD_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Logbook',
                    required: true,
                });
                return setLogBookUploadValid(error);

            case VALUATION_REPORT_SET_VALUE:
                error = validateBase64File(action.value, { subject: 'Valuation Report', required: false });
                return setValuationReportUploadValid(error);

            case INSPECTION_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, { subject: 'Inspection Photo', required: false });
                return setInspectionPhotoValid(error);

            case CAR_FRONT_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Image of front view including the number plate',
                    required: true,
                });
                return setCarFrontViewPhotoValid(error);

            case CAR_BACK_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Image of back/rear including the number plate',
                    required: true,
                });
                return setCarBackViewPhotoValid(error);

            case CAR_RIGHT_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Image of right side view of vehicle',
                    required: true,
                });
                return setCarRightPhotoValid(error);

            case CAR_LEFT_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Image of left side view of vehicle',
                    required: true,
                });
                return setCarLeftPhotoValid(error);

            case CHASSIS_NUMBER_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Chassis Number Image',
                    required: true,
                });
                return setChassisNumberPhotoValid(error);

            case INTERIOR_DASHBOARD_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Interior Dashboard Image',
                    required: true,
                });
                return setCarDashboardPhotoValid(error);

            case INTERIOR_RADIO_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Interior Radio Image',
                    required: true,
                });
                return setInteriorRadioPhotoValid(error);

            case ENGINE_PHOTO_SET_VALUE:
                error = validateBase64File(action.value, {
                    subject: 'Engine Photo',
                    required: true,
                });
                return setEnginePhotoValid(error);
            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
